import React from "react";
import css from "@styled-system/css";

import { PrismicColor } from "utils";

import {
  Box,
  Column,
  Columns,
  Heading,
  Text,
  VStack,
  Wrapper,
} from "components";

export function DetailList({
  bottomAngle,
  title,
  topAngle,
  items,
  background,
}) {
  if (items && items[0] && items[0].description)
    return (
      <>
        <Wrapper
          id={title && title.text}
          py={{ _: "layout.5", md: "layout.6" }}
          bg={PrismicColor(background)}
        >
          <Columns spaceX="layout.5" spaceY="layout.4">
            {/* Title */}
            <Column width={{ _: 1 / 1, lg: 4 / 12 }}>
              {title && title.text && (
                <Heading children={title.text} as="h2" size={700} />
              )}
            </Column>
            {/* Items */}
            <Column width={{ _: 1 / 1, lg: 8 / 12 }}>
              <Box
                position="relative"
                css={css({
                  "::before": {
                    content: "''",
                    position: "absolute",
                    top: 0,
                    bottom: 0,
                    left: -32,
                    display: ["none", null, null, "block"],
                    width: "1px",
                    bg: "separator",
                  },
                })}
              >
                <VStack as="ul" space={{ _: "layout.4", md: "layout.5" }}>
                  {items.map((item, i) => {
                    if (item && item.description)
                      return (
                        <Columns
                          spaceX="layout.5"
                          spaceY="spacing.4"
                          key={`listItem-${i}`}
                        >
                          <Column width={{ _: 1 / 1, md: 4 / 12, lg: 2 / 8 }}>
                            {item && item.title && item.title.text && (
                              <Heading
                                children={item.title.text}
                                as="h3"
                                size={500}
                              />
                            )}
                          </Column>
                          <Column width={{ _: 1 / 1, md: 8 / 12, lg: 6 / 8 }}>
                            <Text
                              children={item.description}
                              size={500}
                              maxWidth="40ch"
                            />
                          </Column>
                        </Columns>
                      );
                    else return null;
                  })}
                </VStack>
              </Box>
            </Column>
          </Columns>
        </Wrapper>
      </>
    );
  else return null;
}
